/**
 * InventoryControlModule Constants
 * 後方互換性のためのre-export
 * @deprecated 直接 constants/tableConstants をインポートしてください
 */

// 後方互換性のため既存のエクスポートを維持しつつ、新しい構造にリダイレクト
export * from './constants';

// 個別エクスポートも維持（段階的移行のため）
export { TABLE_IDS, GROUP_MENU, TABLE_LAYOUT, VIRTUAL_SCROLL } from './constants/tableConstants';

// 既存の個別エクスポート（削除予定だが一時的に維持）
export const TABLE_CONTENT_ID = 'inventory-control-table';
export const ORDER_MODE_TABLE_CONTENT_ID = 'order-mode-inventory-control-table';
export const GROUP_MENU_ITEMS = ['CreateGroup', 'AddBusinessToGroup', 'EditGroup', 'DeleteGroup'] as const;
export const GROUP_ACTION_TYPES = ['none', 'create', 'delete', 'updateName', 'addBusiness', 'deleteBusiness'] as const;
export const HEADER_COLUMN_DEFAULT_NUMBER = 54;
export const ORDER_HEADER_COLUMN_DEFAULT_NUMBER = 70;
export const MONTH_DISTANCE_ARRAY = [-3, -2, -1, 0, 1, 2, 3];
export const DISPLAY_INVENTORY_YEAR_MONTH_MAX_RANGE = 24; // 表示可能な最大年月範囲（24ヶ月）
